import { render, staticRenderFns } from "./mobile-payment-result.vue?vue&type=template&id=ed2b7776&scoped=true&"
import script from "./mobile-payment-result.vue?vue&type=script&lang=ts&"
export * from "./mobile-payment-result.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-payment-result.vue?vue&type=style&index=0&id=ed2b7776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2b7776",
  null
  
)

export default component.exports